import Link from 'next/link'
import { useState } from 'react'
import { useGlobalContext } from 'src/contexto/contextoGlobal'

const ALL_CATEGORIES = 'Todas as Categorias'

import ItemDestaque from './itemDestaque'
import {
  CategoryButton,
  CategoryContainer,
  CategoryDropdown,
  CategoryDropdownItemLeft,
  CategoryNav,
  CategorySection,
} from './styles'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import { IconArrow, IconMenu } from '@gazin/ecommerce-ui'
import { OriginLoadingEnum } from 'src/util/enums/origin-loading'

export default function MenuCategorias() {
  const [selectedCategory, setSelectedCategory] = useState('')
  const { isBlackFridayTheme } = useBlackFriday()

  const { menuHeaderData, menuCategoriasData, setOriginLoading } =
    useGlobalContext()
  const menuHeader =
    menuHeaderData && menuHeaderData.itens ? menuHeaderData.itens : null
  const menuCategorias =
    menuCategoriasData && menuCategoriasData.itens
      ? menuCategoriasData.itens
      : null

  const renderCategoryItems = (id, name) => {
    return (
      <ItemDestaque
        key={id}
        title={name}
        opcoes={menuCategorias.find((category) => category.nome === name)}
        isSelected={selectedCategory === name}
      />
    )
  }

  const activeDropdownCategoria = () => {
    const dropdown = document.querySelector('.dropdown-categoria')
    dropdown.classList.add('active')
  }
  const closeDropdownCategoria = () => {
    const dropdown = document.querySelector('.dropdown-categoria')
    dropdown.classList.remove('active')
  }

  const buildUrl = (menu) => {
    let url = {
      categoria: {
        href: '/categoria/[...categoria]',
        as: `/categoria/${menu.parametros.categoria_slug}`,
      },
      pagina: {
        href: '/pagina/[...pagina]',
        as: `/pagina/${menu.parametros.pagina_slug}`,
      },
      url: {
        href: `${menu.parametros.url}`,
      },
    }

    return url[menu.chave_tipo]
  }

  return (
    <CategorySection darkTheme={isBlackFridayTheme}>
      <CategoryContainer>
        <CategoryButton
          type="button"
          onMouseOver={menuCategorias ? () => activeDropdownCategoria() : null}
          darkTheme={isBlackFridayTheme}
        >
          <IconMenu height=".9375rem" width="1.25rem" marginRight="1rem" />
          <span>Todas categorias</span>
        </CategoryButton>
        <CategoryNav>
          <ul>
            {menuHeader?.map((menu) => {
              return menu.id > 5 ? (
                <li key={menu.id} onMouseOver={() => closeDropdownCategoria()}>
                  <Link
                    {...buildUrl(menu)}
                    prefetch={false}
                    target={menu.parametros.target ?? '_self'}
                    onClick={() => {
                      setOriginLoading(OriginLoadingEnum.CATEGORY)
                    }}
                  >
                    {menu.nome}
                  </Link>
                </li>
              ) : null
            })}
          </ul>
        </CategoryNav>
        <CategoryDropdown
          className="dropdown-categoria"
          onMouseLeave={() => closeDropdownCategoria()}
          darkTheme={isBlackFridayTheme}
        >
          <CategoryDropdownItemLeft darkTheme={isBlackFridayTheme}>
            <ul>
              {Array.isArray(menuCategorias) &&
                menuCategorias &&
                menuCategorias.map((subCategoria, keyCategoria) => {
                  return subCategoria.id !== 307 && keyCategoria < 11 ? (
                    <li
                      key={subCategoria.id}
                      onMouseOver={() => setSelectedCategory(subCategoria.nome)}
                    >
                      <Link
                        href="/categoria/[...categoria]"
                        as={`/categoria/${subCategoria.parametros.categoria_slug}`}
                        prefetch={false}
                        onClick={() => {
                          setOriginLoading(OriginLoadingEnum.CATEGORY)
                        }}
                      >
                        {subCategoria.nome}
                        <IconArrow color="#DCDDE3" alt={subCategoria.nome} />
                      </Link>
                    </li>
                  ) : null
                })}
              {menuCategorias && menuCategorias.length >= 1 && (
                <li
                  key={'Todas_as_Categorias'}
                  onMouseOver={() => setSelectedCategory(ALL_CATEGORIES)}
                >
                  <button type="button">
                    Todas as Categorias
                    <IconArrow color="#DCDDE3" alt={ALL_CATEGORIES} />
                  </button>
                </li>
              )}
            </ul>
          </CategoryDropdownItemLeft>
          <div className="dir">
            {Array.isArray(menuCategorias)
              ? menuCategorias?.map((categoria) =>
                  renderCategoryItems(categoria.id, categoria.nome)
                )
              : null}
            <ItemDestaque
              title={ALL_CATEGORIES}
              opcoes={menuCategorias}
              isSelected={selectedCategory === ALL_CATEGORIES}
            />
          </div>
        </CategoryDropdown>
      </CategoryContainer>
    </CategorySection>
  )
}
